<script setup>
  import { useI18n } from 'vue-i18n';
  import ToolbarHeaderActionListBase from "@/components/ToolbarHeaderActionListBase.vue";
  import Icon from "@/components/icons/Icon.vue";

  const { t } = useI18n();

  const showSettingsModal = defineModel('showSettingsModal', { required: true });
</script>

<template>  
  <ToolbarHeaderActionListBase>
    <template #default="{ classes }">
      <li :class="classes.item">
        <button
          @click="showSettingsModal = true"
          type="button"
          :class="classes.button"
        >
          <Icon name="gear" :class="classes.icon" />
          <span :class="classes.label">{{ t('common.settings') }}</span>
        </button>
      </li>
    </template>
  </ToolbarHeaderActionListBase>
</template>